<template>
    <v-tooltip top color="orange" v-model="copied">
        <template v-slot:activator="{ on, attrs }">
            <v-tooltip bottom color="orange" v-model="copiedInner">
                <template v-slot:activator="{ on, attrs }">
                    <slot :click="click" :attrs="attrs" :on="on"></slot>
                </template>
                <span>{{ tooltip }}</span>
            </v-tooltip>
        </template>
        <span>{{ copiedTooltip }}</span>
    </v-tooltip>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                required: true
            },
            tooltip: {
                type: String,
                default: 'Click to copy text'
            },
            copiedTooltip: {
                type: String,
                default: 'Text copied to clipboard!'
            }
        },
        data: () => ({
            copied: false,
            copiedInner: false
        }),
        methods: {
            click() {
                navigator.clipboard.writeText(this.text);
                this.copiedInner = false;
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                    this.copiedInner = false;
                }, 3000);
            }
        }
    }
</script>
